import { render, staticRenderFns } from "./DsioReset.vue?vue&type=template&id=210f8ee9&"
import script from "./DsioReset.vue?vue&type=script&lang=js&"
export * from "./DsioReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/su_laetis/workspaces/structure-wordpress-php8/httpsdocs/plugins/lae-elementor-diffusio/libs/diffusio/ressources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('210f8ee9')) {
      api.createRecord('210f8ee9', component.options)
    } else {
      api.reload('210f8ee9', component.options)
    }
    module.hot.accept("./DsioReset.vue?vue&type=template&id=210f8ee9&", function () {
      api.rerender('210f8ee9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/DsioReset.vue"
export default component.exports